// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  id: __t.string(),
  token: __t.string(),
  projectId: __t.string(),
  jobId: __t.string(),
  label: __t.string(),
  allowComments: __t.bool(),
  expiresInDays: __t.u32(),
  allowDecisions: __t.bool(),
  expiresAtMs: __t.f64(),
};
